<style>
  *{
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}
  .goodsManageTable{
    width:100%;

  }
  .el-table .cell{
    text-align: center;
    min-height:15px;
  }
  .editMeng{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: rgba(75, 75, 75, 0.3);
  }
</style>

<template>
  <div class='goodsManageTable'>
    <el-table
			ref="multipleTable"
			max-height='630'
			@filter-change='filterHandler'
			:border='true'
			:header-cell-style='{"background-color":"#333",color:"#eee"}'
			:data="tableData"
			tooltip-effect="dark"
			style="width: 100%"
			@selection-change="handleSelectionChange"
		>
        <el-table-column type="selection" v-if='deleteType'/>
        <el-table-column type='index' label="序号" width="50"/>
        <el-table-column
					column-key='class'
					filter-placement='bottom' 
					:filters="filterOptions.class" 
					:filter-multiple='false'
				>
          <template slot="header">
            <div class="tableHeader">
              <div>分类</div>
              <div class="filterValue" :title="filters.class[0]" v-if="filters.class && filters.class.length > 0">{{filters.class[0]}}</div>
            </div>
          </template>
          <template slot-scope="scope"><span>{{ scope.row.class }}</span></template>
        </el-table-column>
	    	<el-table-column
					column-key='type'
					filter-placement='bottom' 
					:filters="filterOptions.type" 
					:filter-multiple='false'
				>
					<template slot="header">
            <div class="tableHeader">
              <div>材质</div>
              <div class="filterValue" :title="filters.type[0]" v-if="filters.type && filters.type.length > 0">{{filters.type[0]}}</div>
            </div>
          </template>
          <template slot-scope="scope"><span>{{ scope.row.type }}</span></template>
        </el-table-column>
				<el-table-column 
					column-key='color'
					filter-placement='bottom'
					:filters="filterOptions.color"
					:filter-multiple='false'
				>
					<template slot="header">
            <div class="tableHeader">
              <div>颜色</div>
              <div class="filterValue" :title="filters.color[0]" v-if="filters.color && filters.color.length > 0">{{filters.color[0]}}</div>
            </div>
          </template>
          <template slot-scope="scope"><span >{{ scope.row.color }}</span></template>
        </el-table-column>
        <el-table-column
					column-key='thick'
					filter-placement='bottom'
					:filters="filterOptions.thick"
					:filter-multiple='false'
				>
					<template slot="header">
            <div class="tableHeader">
              <div>厚度mm</div>
              <div class="filterValue" :title="filters.thick[0]" v-if="filters.thick && filters.thick.length > 0">{{filters.thick[0]}}</div>
            </div>
          </template>
          <template slot-scope="scope"><span >{{ scope.row.thick }}</span></template>
        </el-table-column>
        <el-table-column
					column-key='spec'
					filter-placement='bottom'
					:filters="filterOptions.spec"
					:filter-multiple='false'
				>
					<template slot="header">
            <div class="tableHeader">
              <div>规格</div>
              <div class="filterValue" :title="filters.spec[0]" v-if="filters.spec && filters.spec.length > 0">{{filters.spec[0]}}</div>
            </div>
          </template>
          <template slot-scope="scope"><span >{{ scope.row.spec }}</span></template>
        </el-table-column>
        <el-table-column  label="图片">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px ; cursor: pointer;" :src="scope.row.pictures.length?(scope.row.pictures[0].url?scope.row.pictures[0].url:scope.row.pictures[0]):''" fit="cover" @click="showUpImg(scope.row)">
              <div slot="error" class="image-slot" @click="showUpImg(scope.row)">
                <i  style='cursor: pointer;' class='el-icon-picture'></i>
              </div>
            </el-image>
            <p v-if="scope.row.pictures.length">{{scope.row.pictures.length}}张</p>
          </template>
        </el-table-column>
        <el-table-column  label="备注">
            <template slot-scope="scope"><span style="cursor: pointer;width:100%;display: block;min-height:15px;color:#5757fa;" @click='updateGoods(scope.row,"remarks","备注")'>{{ scope.row.remarks }}</span></template>
        </el-table-column>
        <el-table-column  label="名称">
            <template slot-scope="scope"><span style="cursor: pointer;width:100%;display: block;min-height:15px;color:#5757fa;" @click='updateGoods(scope.row,"name","名称")'>{{ scope.row.name }}</span></template>
        </el-table-column>
        <el-table-column  label="采购价">
            <template slot-scope="scope"><span style="cursor: pointer;width:100%;display: block;min-height:15px;color:#5757fa;" @click='updateGoods(scope.row,"pur_price","采购价")'>{{ scope.row.pur_price  }}</span></template>
        </el-table-column>
        <el-table-column  label="仓库调货价">
            <template slot-scope="scope"><span style="cursor: pointer;width:100%;display: block;min-height:15px;color:#5757fa;" @click='updateGoods(scope.row,"adj_price","仓库调货价")'>{{ scope.row.adj_price  }}</span></template>
        </el-table-column>
        <el-table-column  label="会员价">
            <template slot-scope="scope"><span style="cursor: pointer;width:100%;display: block;min-height:15px;color:#5757fa;" @click='updateGoods(scope.row,"price","会员价")'>{{ scope.row.price }}</span></template>
        </el-table-column>
        <el-table-column  label="零售价">
            <template slot-scope="scope"><span style="cursor: pointer;width:100%;display: block;min-height:15px;color:#5757fa;" @click='updateGoods(scope.row,"ret_price","零售价")'>{{ scope.row.ret_price  }}</span></template>
        </el-table-column>
        <el-table-column  label="操作">
          <template slot-scope="scope"><span @click="changeEdit(scope.row)" style="color:#6376F7;cursor: pointer;">编辑</span></template>
        </el-table-column>
    </el-table>
    <div class="editMeng" v-if="editBoxShow" @click="editBoxShow = false"></div>
    <editBox v-if="editBoxShow" :info='needChangeData.id?needChangeData:""' @hideEditBox='hideEditBox' @getList='refreshTable'></editBox>
    <!-- <p style='text-align: right;margin-top:30px;'><el-button v-show='nowPage>1' @click='changePage(-1)'>上一页</el-button><el-button v-show='(allPage-nowPage)>0' @click='changePage(1)'>下一页</el-button></p> -->
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handlePageChange"
        :page-size="form.limit"
        :current-page.sync="form.page"
      >
      </el-pagination>
    </div>
		<UpdateImg :clickImgUrl='clickImgUrl' :clickRowId='clickRowId' :pictures='pictures' v-if="imgBoxShow" @hideUpImg='hideUpImg'></UpdateImg>
  </div>
</template>

<script>
  import UpdateImg from '../otherUpdateImg'
  import editBox from './cabinetBox'

  import { processingFilterOptions, getKeyValueWithFilter } from '../../../../util/processingData';
  // import { getObjectList, getFilterOptions } from '../../../../util/requests';
  export default {
    components: {
      UpdateImg,
      editBox
    },
    props: {
      'deleteType':{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {
        needChangeData:{},
        editBoxShow:false,
        filters: {},
        filterOptions: {
          class: [],
          type: [],
          spec: [],
          color: [],
          thick: []
        },
        tableData: [],
        total:0,
        multipleSelection: [],
        nowPage:1,
        allPage:1,
        pictures:[],
        form:{
          page:1,
          limit:20,
          // name:"",
          supplier_id:0,
          uid:this.$store.state.userInfo.id,
          part_type:'cabinet'
        },
        clickImgUrl:'',
        clickRowId:0,
        clickRow:"",
        imgBoxShow:false
      }


    },
    computed: {
        supplier_id(){
          if(this.$store.state.supplierInfo){
            return this.$store.state.supplierInfo.id
          }else{
            return 0
          }
				},
				userInfo(){
          return this.$store.state.userInfo
        },
        deleteCount(){
          return this.multipleSelection.length
        }
    },
    watch:{
      deleteCount(val){
        this.$emit('changeDeleteCount',val)
      }
    },
    mounted() {
      this.form.supplier_id=this.supplier_id
      this.updateTable(1);
      this.getFilterOptions();
    },
    methods: {
      refreshTable() {
				this.form.page = 1;
				this.updateTable(1);
				this.getFilterOptions();
			},
      handlePageChange(page) {
        this.form.page = page;
        // this.getList();
        this.updateTable(page);
      },
      filterHandler(filters) {
        console.log('选中商品',filters)
        let keyTarget = ''; // 这个值标明本次变化的属性，其选项列表不改变，以方便用户反复操作同一个属性的选项
        for (let key in filters) {
          this.filters[key] = filters[key];
          if (filters[key].length > 0) {
            keyTarget = key; // 当前属性选项不为‘全部’时，需要保留当前选项，否则根据后端返回更新
          }
        }

        // 获取未选择过滤器的其他属性过滤器列表
        this.getFilterOptions(keyTarget);

        // 置page为1，并获取商品列表更新
        this.form.page = 1;
        this.updateTable(1);
      },
      getFilterOptions(keyTarget) {
        const keyValue = getKeyValueWithFilter(this.filters);
        keyValue.part_type = this.form.part_type;
        this.$requests.getFilterOptions(
          this.userInfo.id,
          this.form.supplier_id,
          keyValue
        ).then((res) => {
            const newFilters= processingFilterOptions(res, keyTarget);
            for (let key in newFilters) {
              this.filterOptions[key] = newFilters[key];
            }
        })
        // axios.get(`https://ggtools.thinkerx.com/erp/get_class_list?uid=${this.userInfo.id}&supplier_id=${this.supplier_id}&part_type=plank`).then((res) => {
        //   if (res.data.status == 1) {
        //     const list = res.data.data;

        //     const filters = processingFilterOptions(list);
        //     for (let key in filters) {
        //       this.filterOptions[key] = filters[key];
        //     }
        //   }
        // })
      },
      updateTable(page) {
        // 通过当前过滤器，获取keyValue，传入getObjectList方法，获取到过滤规则下的商品列表
        const keyValue = getKeyValueWithFilter(this.filters);
				keyValue.part_type = this.form.part_type;
				keyValue.limit = this.form.limit;
        if (this.form.name) {
          keyValue.name = this.form.name;
        }
        
        this.$requests.getObjectList(
          this.form.uid,
          this.form.supplier_id,
          keyValue,
          page
        ).then((res) => {
          if (res.list.length == 0 && res.count !== 0) {
            this.form.page--;
            this.updateTable(this.form.page);
            return;
          }
          this.total = res.count;
          this.tableData = res.list;
        })
      },
      hideEditBox(){
        this.editBoxShow = false
      },
      changeEdit(data){
        this.editBoxShow = !this.editBoxShow
        if(data){
          this.needChangeData = data
          console.log(data)
        }else{
          this.needChangeData = {}
        }
      },
      changePage(cha){
        this.form.page+=cha
        this.nowPage+=cha
        this.getList()
      },
      getList(){
        // console.log(this.$store.state.supplierInfo)
        // console.log(this.form)
        // this.axios.get('https://ggtools.thinkerx.com/erp/get_product_list',{
        //   params:this.form
        // }).then(res => {
        //   this.total = res.data.data.total
        //   this.allPage = Math.ceil(this.total/this.form.limit)
        //   this.tableData=res.data.data.list
        // })
        
        this.$get("/py/erp/get_product_list",this.form,res => {
           console.log('vr列表',res.data)
           this.total = res.data.total
          this.allPage = Math.ceil(this.total/this.form.limit)
          this.tableData=res.data.list
        })
        // this.axios({
        //   url:'//ggtools.thinkerx.com/erp/get_product_list',
        //   data:this.form
        // }).then(res=>{
        //   res=res.data
        //   console.log(res)
        // })
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleSelectionChange(val) {
        console.log('选中商品',val)
        this.multipleSelection = val;
      },
      clearDelete(){
        this.$refs.multipleTable.clearSelection();
      },
      deleteGoods(){
        //等待接口
        let idArr = []
        let multipleSelection = this.multipleSelection
        for(let i in multipleSelection){
          idArr.push(multipleSelection[i].id)
        }
        console.log('传递要删除的商品id数组',idArr)

        // this.axios({
        //   method: 'POST',
        //   url:'https://ggtools.thinkerx.com/erp/delete_product_list',
        //   data: {
        //     ids: idArr
        //   }
        // }).then(res => {
        //   console.log('删除返回结果',res.data)
        //   if(res.data.status == 1){
        //     this.$message({
        //       type: 'success',
        //       message: '删除成功'
        //     });
        //   }
        // })
        this.$post("/py/erp/delete_product_list",{
          ids: idArr
        },res => {
          if(res.status == 1){
            this.$message({
              type: 'success',
              message: '删除成功'
            });
					}
					this.updateTable(this.form.page);
          this.getFilterOptions();
        })
        // let tableData = this.tableData
        // for(let i in tableData){
        //     for(let j in idArr){
        //       if(tableData[i].id == idArr[j]){
        //         tableData.splice(i,1)
        //       }
        //     }
        // }
        // console.log('---------------------',tableData)
      },
      filter(keywords){
          this.form.page=1
          this.form.name=keywords
          // this.getList()
          this.updateTable(1);
      },
      updateGoods(row,type,typeName){
        this.$prompt('请输入'+typeName, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue:row[type]?row[type]:''  //默认值
        }).then(({ value }) => {
          if(type!="remarks" && type!="name"){
            if(isNaN(Number(value))){
              this.$message({
                type: 'info',
                message: '请输入正确的数值'
              });
              return
            }
          }
          console.log(type,typeName)
          // let Update = {
          //   id:row.id,
          //   supplier_id:this.$store.state.supplierInfo.id,
          //   name:row.name,  //板材名称
          //   price:Number(row.price),  //会员价
          //   adj_price:Number(row.adj_price),  //仓库调货价
          //   ret_price:Number(row.ret_price),  //零售价
          //   pur_price:Number(row.pur_price)   //采购价
          // }
          let Update = {
            id:row.id,
            uid:this.$store.state.userInfo.id,
            supplier_id:this.supplier_id,
          }
          Update[type] = value
          console.log(Update)
          // this.axios.post('https://ggtools.thinkerx.com/erp/update_product_list',Update).then(res => {
          //   let resData = res.data
          //   if(resData.status == 1){
          //     this.$message({
          //       type: 'success',
          //       message: '修改成功'
          //     });
          //     row[type]=value
          //   }else if(resData.status == -1){
          //     this.$message({
          //       type: 'error',
          //       message: resData.msg
          //     });
          //   }
          // })
          this.$post("/py/erp/update_product_list",Update,res => {
            let resData = res
            if(resData.status == 1){
              this.$message({
                type: 'success',
                message: '修改成功'
              });
              row[type]=value
            }else if(resData.status == -1){
              this.$message({
                type: 'error',
                message: resData.msg
              });
            }
          })
        }).catch(() => {

        });
      },
      showUpImg(row){
        let url=row.pictures.length==0?'':row.pictures[0]
        // 传给弹窗的imgUrl
        this.pictures = row.pictures
        this.clickImgUrl = url
        this.clickRowId = row.id
        this.clickRow=row
        // console.log(row)
        this.imgBoxShow = true
      },
      hideUpImg(nowPictures,id){
        this.imgBoxShow = false
        // 回调的imgUrl
        // console.log(nowPictures)
        if(nowPictures&&id){
          let Update = {
            id:id,
            uid:this.$store.state.userInfo.id,
            supplier_id:this.supplier_id,
            pictures:nowPictures
          }
          // console.log(Update)
          // this.axios.post('https://ggtools.thinkerx.com/erp/update_product_list',Update).then(res => {
          //   let resData = res.data
          //   if(resData.status == 1){
          //     this.$message({
          //       type: 'success',
          //       message: '图片上传成功'
          //     });
          //     this.clickRow.pictures=nowPictures
          //   }else if(resData.status == -1){
          //     this.$message({
          //       type: 'error',
          //       message: resData.msg
          //     });
          //   }
          // })
          this.$post("/py/erp/update_product_list",Update,res => {
            let resData = res
            if(resData.status == 1){
              this.$message({
                type: 'success',
                message: '图片上传成功'
              });
              this.clickRow.pictures=nowPictures
            }else if(resData.status == -1){
              this.$message({
                type: 'error',
                message: resData.msg
              });
            }
          })
        }
      }
    }
  }
</script>
